var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFormatUndefined = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#3B3F4E",
  d: "M5 2h8.586a1 1 0 0 1 .707.293l5.414 5.414a1 1 0 0 1 .293.707V21.5s.237 1-.863 1h-14C4 22.5 4 21.5 4 21.5V2.818S4 2 5 2m0 17v2.5h14V8h-5V3H5z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#3B3F4E",
  d: "M7 13.5a.5.5 0 0 1 .5-.5h9a.5.5 0 1 1 0 1h-9a.5.5 0 0 1-.5-.5m0 4a.5.5 0 0 1 .5-.5h9a.5.5 0 1 1 0 1h-9a.5.5 0 0 1-.5-.5"
})));
export default SvgFormatUndefined;